import React from 'react';
import './styles/index.less';

interface TabButtonProps {
  id: string;
  label: string;
  isActive: boolean;
  onClick: () => void;
}

const TabButton: React.FC<TabButtonProps> = ({ id, label, isActive, onClick }) => {
  return (
    <button
      onClick={onClick}
      className={`tab-button ${isActive ? 'active' : ''}`}
      data-tab={id}
    >
      <span>{label}</span>
    </button>
  );
};

export default TabButton;